import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { Viewport, ViewLarge, ViewExtraLarge } from '@shared-ui/viewport-context';
import { E as EGDSLayoutGrid, a as EGDSLayoutGridItem, e as MinMax } from '../layout-grid-item/index-chunk.esm.js';
import { b as EGDSSpacing } from '../spacing-hr/index-chunk.esm.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-view.css';
import { d as EGDSLayoutPosition } from '../layout-position/index-chunk.esm.js';
const getClassNameList$3 = classNames.bind(styles);
class EGDSView extends React.PureComponent {
  static displayName = 'EGDSView';
  render() {
    const {
      children,
      className
    } = this.props;
    const cssClassNames = getClassNameList$3('uitk-view', className);
    return jsx("div", {
      className: cssClassNames,
      children: children
    });
  }
}
const getClassNameList$2 = classNames.bind(styles);
class EGDSViewRow extends React.PureComponent {
  static displayName = 'EGDSViewRow';
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    adSlot: false,
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    canvasTheme: 'primary',
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    layout: 'fullwidth'
  };
  render() {
    const {
      adSlot,
      children,
      className,
      canvasTheme,
      layout
    } = this.props;
    const cssClassNames = getClassNameList$2('uitk-view-row', `uitk-view-row-theme-${canvasTheme}`, `uitk-view-row-layout-${layout}`, `uitk-view-row-adslot-${adSlot}`, className);
    return jsx("div", {
      className: cssClassNames,
      children: children
    });
  }
}
const getClassNameList$1 = classNames.bind(styles);
class EGDSViewTemplateSearchResults extends React.Component {
  static displayName = 'EGDSViewTemplateSearchResults';
  render() {
    const {
      adSlot = true,
      changeSearch,
      loadingBar,
      searchHeading,
      searchFilters,
      searchResults,
      sideRailAd
    } = this.props;
    return jsxs(EGDSView, {
      children: [jsx(EGDSSpacing, {
        padding: {
          block: 'three'
        },
        children: jsx(EGDSViewRow, {
          layout: "centered",
          adSlot: sideRailAd ? true : adSlot,
          children: jsx(EGDSLayoutGrid, {
            space: "six",
            children: jsx(EGDSLayoutGridItem, {
              className: getClassNameList$1('uitk-view-searchresults-changesearch'),
              colSpan: "all",
              children: jsx(EGDSLayoutPosition, {
                type: "relative",
                children: changeSearch
              })
            })
          })
        })
      }), jsx(EGDSLayoutPosition, {
        position: {
          top: 'minus-one',
          left: 'zero',
          right: 'zero'
        },
        type: "relative",
        children: loadingBar
      }), jsx(EGDSSpacing, {
        margin: {
          blockend: 'three',
          blockstart: 'six'
        },
        children: jsxs(EGDSViewRow, {
          canvasTheme: "secondary",
          layout: "centered",
          adSlot: sideRailAd ? true : adSlot,
          children: [jsxs(EGDSLayoutGrid, {
            columns: {
              large: [MinMax('0x', '3fr'), MinMax('0x', '9fr')]
            },
            space: "six",
            alignContent: "start",
            children: [jsx(EGDSLayoutGridItem, {
              colSpan: "all",
              children: jsx("div", {
                children: searchHeading
              })
            }), jsx(Viewport, {
              children: jsx(ViewLarge, {
                children: jsx(EGDSLayoutGridItem, {
                  children: jsx("aside", {
                    children: searchFilters
                  })
                })
              })
            }), jsx(EGDSLayoutGridItem, {
              children: jsx("section", {
                children: searchResults
              })
            })]
          }), sideRailAd && jsx(Viewport, {
            children: jsx(ViewExtraLarge, {
              children: sideRailAd
            })
          })]
        })
      })]
    });
  }
}
const getClassNameList = classNames.bind(styles);
class EGDSViewTemplateInfosite extends React.Component {
  static displayName = 'EGDSViewTemplateInfosite';
  render() {
    const {
      stepIndicator,
      detailsReview,
      priceBreakdown,
      banners,
      legalInfo,
      sideRailAd,
      adSection,
      canvasTheme,
      alignItems = 'start'
    } = this.props;
    return jsx(EGDSView, {
      children: jsx(EGDSSpacing, {
        margin: {
          blockstart: 'six'
        },
        children: jsxs(EGDSViewRow, {
          canvasTheme: canvasTheme ?? 'secondary',
          layout: "centered",
          adSlot: !!sideRailAd,
          children: [jsxs(EGDSLayoutGrid, {
            columns: {
              large: [MinMax('0x', '2fr'), MinMax('0x', '1fr')]
            },
            space: "six",
            alignItems: alignItems,
            tag: "main",
            children: [jsx(EGDSLayoutGridItem, {
              colSpan: "all",
              children: jsx("section", {
                children: stepIndicator
              })
            }), jsx(EGDSLayoutGridItem, {
              children: jsxs(EGDSLayoutGrid, {
                space: "six",
                children: [banners && jsx("section", {
                  className: getClassNameList(banners.isHidden ? 'is-hidden' : ''),
                  children: banners.content ? banners.content : banners
                }), jsx(EGDSLayoutGridItem, {
                  children: jsx("section", {
                    children: detailsReview
                  })
                }), legalInfo && jsx(EGDSLayoutGridItem, {
                  children: jsx("section", {
                    children: legalInfo
                  })
                })]
              })
            }), jsx(EGDSLayoutGridItem, {
              children: jsx("section", {
                children: priceBreakdown
              })
            }), jsx(EGDSLayoutGridItem, {
              children: jsx("section", {
                children: adSection
              })
            })]
          }), sideRailAd && jsx(Viewport, {
            children: jsx(ViewExtraLarge, {
              children: sideRailAd
            })
          })]
        })
      })
    });
  }
}
export { EGDSView as E, EGDSViewRow as a, EGDSViewTemplateSearchResults as b, EGDSViewTemplateInfosite as c };